import { Box, Grid, Typography } from "@material-ui/core";
import React from "react";
import AwardCategoryForm from "../AwardCategoryListingPage/AwardCategoryForm";

export default function AwardCategoryDetailPage(props) {
  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Awards & Juries &gt; Award Category
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={6}>
          <AwardCategoryForm
            formTitle="Edit Award Category"
            buttonText="Save"
          />
        </Grid>
      </Grid>
    </>
  );
}
